/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharp_Chunky_Iguana_RadiateInputs */

const fr_sharp_chunky_iguana_radiate = /** @type {(inputs: Sharp_Chunky_Iguana_RadiateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créez une nouvelle catégorie pour organiser vos programmes de fitness. Configurez la visibilité et ajoutez une description détaillée.`)
};

/**

* @param {Sharp_Chunky_Iguana_RadiateInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const sharp_chunky_iguana_radiate = /** @type {((inputs?: Sharp_Chunky_Iguana_RadiateInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharp_Chunky_Iguana_RadiateInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_sharp_chunky_iguana_radiate(inputs)
});